import { OrderOQResponse } from '../models/order/api-models/order-oq-response.model';

/**
 * Returns the SIGFAN discount that Order Qualification quoted for a wireless line, or null when OQ
 * cannot be trusted for it. The provider recalculates every line's FAN discount whenever lines
 * change, so OQ (which prices all lines together) is preferred over a line's cached PD+ response.
 * When OQ does not list exactly the lines in progress, the order changed after OQ and the caller
 * falls back to the latest active PD+ response.
 */
export function getOqLineFanDiscount(
    oqResponse: OrderOQResponse | null | undefined,
    lineNumber: number,
    linesInProgress: number | null | undefined
): number | null {
    const wirelessLines = oqResponse?.Components?.Component
        ?.find(component => component?.ProductType === 'WIRELESS')
        ?.WirelessLines?.WirelessLine;
    if (!wirelessLines?.length || !linesInProgress || wirelessLines.length !== linesInProgress) return null;

    const discount = wirelessLines.find(line => +line?.LineNumber === +lineNumber)?.SigFanDiscount;
    if (discount === null || discount === undefined || `${discount}`.trim() === '') return null;

    const amount = Number(discount);
    return Number.isFinite(amount) ? amount : null;
}
